<script setup lang="ts">
// composables
const display = useDisplay()

// stores
const appStore = useAppStore()

// refs
const {
  miniDrawer,
  navDrawer,
} = storeToRefs(appStore)

// methods
function toggle() {
  if (display?.xs?.value)
    navDrawer.value = !navDrawer.value
  else
    miniDrawer.value = !miniDrawer.value
}
</script>

<template>
  <v-app-bar color="primary">
    <template #prepend>
      <v-img
        height="40px"
        src="/logo-white.png"
        width="50px"
      />
      <v-expand-x-transition>
        <v-img
          v-if="!miniDrawer"
          class="ml-n1 mt-2"
          height="50px"
          src="/logo-text-white.png"
          width="120px"
        />
      </v-expand-x-transition>
    </template>
    <BaseButtonIcon
      class="ml-1"
      :icon="miniDrawer ? '$mdiMenuClose' : '$mdiMenuOpen'"
      size="default"
      :toolbar="false"
      :tooltip-text="miniDrawer ? 'Open Drawer' : 'Close Drawer'"
      @click="toggle"
    />

    <v-spacer />

    <DialogAccount />

    <BadgeCart />

    <template #append>
      <MenuAccount />
    </template>
  </v-app-bar>
</template>
